import { render, staticRenderFns } from "./SubscriptionPage.vue?vue&type=template&id=87bf7a3a&scoped=true&lang=pug"
import script from "./SubscriptionPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionPage.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPage.vue?vue&type=style&index=0&id=87bf7a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bf7a3a",
  null
  
)

export default component.exports